module.exports = __webpack_public_path__ + "img/product-sm-4.55d5d005.png";